<template>
  <div class="cosmo-footer">
    <div class="footer-content" style="z-index: 999">
      <div class="friendly-links">
        <div>
          <div class="title">
            {{ footerItemObj.title }}
          </div>
          <div
            v-for="(link, index) in footerItemObj.items"
            :key="index"
            class="content contentMobile"
          >
            <template v-if="!link.hideOnMobile || isNotMobile">
              <img v-if="link.icon" :src="link.icon" class="footerIcon" />
              <a
                :href="`${link.title.indexOf('@') > -1 ? 'mailto' : 'tel'}:${
                  link.title
                }`"
                class="footerSpan"
                >{{ link.title }}</a
              >
            </template>
          </div>
          <div v-if="isNotMobile" class="addrDetail">
            <span>China Asia：</span><br />
            <span class="line"
              >Qingdao: Room 2305， Building D1，<br />
              Qingdao International Innovation Park，<br />
              Laoshan District， Qingdao， China;</span
            >
            <span class="line1"
              >Shanghai: 12/F， Building 1<br />
              G60 Rafael Sky City，Lane 288， Qianfan Road<br />
              Songjiang District， Shanghai， China</span
            >
            <span class="line-nb"
              >Ningbo: Room 605, Block 1<br />
              No.40, No.1069, Xinda Road, Daqi Street<br />
              Beilun District, Ningbo City, Zhejiang Province, 315899</span
            >
          </div>
        </div>
        <div v-for="links in categories" :key="links.title">
          <div>
            <div class="title">
              {{ links.title }}
            </div>
            <div
              v-for="(link, index) in links.items"
              :key="index"
              class="content"
            >
              <img v-if="link.icon" :src="link.icon" class="footerIcon" />
              <router-link
                class="footerSpan"
                :to="
                  link.url ||
                  `/products-list/${link.name
                    .split(' ')
                    .map((item) => item.toLowerCase())
                    .join('-')}/${link.id}`
                "
                >{{ link.name }}</router-link
              >
            </div>
          </div>
        </div>
        <div v-for="links in footerItems" :key="links.title">
          <div>
            <div class="title">
              {{ links.title }}
            </div>
            <div
              v-for="(link, index) in links.items"
              :key="index"
              class="content"
            >
              <img v-if="link.icon" :src="link.icon" class="footerIcon" />
              <span class="footerSpan" @click="footerGoPage(link)">{{
                link.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-link class="footerSpan" style="z-index: 1000" to="/site-map"
      >SITE MAP</router-link
    >
    <router-link
      class="footerSpan"
      style="z-index: 1000; margin-left: 2rem"
      to="/privacy-policy"
      >PRIVACY POLICY</router-link
    >
    <div class="copyRight">
      Copyright © {{ year }} 海尔数字科技版权所有 沪ICP17042923
      沪公网安备31011702004474
    </div>
  </div>
</template>

<script>
import "./_CosmoFooter.scss";
import { footerItems, footerItemObj } from "./footerItem.js";
import { palFormUrl } from "../../config/appConfig";
import { customFetch } from "../../utils/api";
export default {
  name: "CosmoFooter",
  props: {},
  data() {
    return {
      footerItems,
      footerItemObj,
      year: 2021,
      categories: [
        {
          title: "Products And Service",
          isLink: false,
          showInMobile: false,
          isAboutUs: true,
          items: [],
        },
      ],
      friendlyLinks: [
        {
          title: "Contact Us",
          isLink: false,
          showInMobile: false,
          items: ["RFQs", "Product Directory", "Supplier Directories"],
        },
        {
          title: "For Suppliers",
          isLink: false,
          showInMobile: false,
          items: ["RFQs"],
        },
        {
          title: "About",
          isLink: true,
          showInMobile: false,
          items: [
            {
              text: "About us",
              route: "About",
            },
            "Contact us",
          ],
        },
        {
          title: "Hai-Industry",
          isLink: false,
          showInMobile: true,
          items: [
            "China Asia:",
            "Qingdao",
            "Address: Shunguang Building, No.1 Haier Road, Qingdao, Shandong Province",
            "",
            "Shanghai",
            "Address: F3 Twin Tower A, No.668 Xinzhuan Road, Songjiang Hi-Tech Park Shanghai, China 201600",
            "Tel: +86 21 67696068 / +86 18917199902 / +86 4001357277",
            "Wechat: Yokini",
            {
              text: "Email: wangyu.cosmo@haier.com",
              mail: "wangyu.cosmo@haier.com",
            },
          ],
        },
      ],
    };
  },
  computed: {
    isNotMobile() {
      return !this.$store.state.isMobile;
    },
  },
  created() {
    let date = new Date();
    this.year = date.getFullYear();
    this.getCategory();
  },
  methods: {
    getCategory() {
      customFetch(
        `${palFormUrl}/international/getInternationalProductsCategoryList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: 0,
          }),
        },
        (res) => {
          this.categories[0].items = res.result;
          this.categories[0].items.push({
            name: "After-Sale Service",
            anchorName: "worldInsertCharts",
            url: "/",
          });
          console.log(this.categories[0]);
        },
        () => {}
      );
    },
    footerGoPage(item) {
      if (item.id) {
        this.$router.push({
          path: item.url,
          query: {
            categoryId: item.id,
            name: item.name,
          },
        });
        return;
      }
      if (item.anchorName == 1 || item.anchorName == 2) {
        this.$router.push({
          path: item.url,
          query: {
            type: item.anchorName,
          },
        });
      }
      if (item.anchorName == "worldInsertCharts") {
        console.log(item);
        this.$router.push({
          path: item.url,
          query: {
            anchorName: item.anchorName,
          },
        });
      }
    },
    handleCommand(command) {
      if (this.$route.name === command) {
        window.scrollTo(0, 0);
        window.location.reload();
      } else {
        this.$router.push({
          name: command,
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.title {
  margin-bottom: 40px;
}

.footerIcon {
  width: 20px;
  padding-right: 10px;
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
}

.footerSpan {
  text-decoration: none;
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
  font-size: 15px;
  color: rgba(187, 187, 187, 1);

  &:hover {
    color: #ccc;
    cursor: pointer;
  }
}
.addrDetail {
  text-align: left;
  position: absolute;
  margin-left: 30px;
  color: rgba(187, 187, 187, 1);
}

.line {
  border-right: 1px solid #7d7d7d;
  float: left;
  padding-right: 40px;
  margin-right: 40px;
  // height: 80px;
}
.line1 {
  border-right: 1px solid #7d7d7d;
  float: left;
  padding-right: 40px;
  margin-right: 40px;
  /*height: 100px;*/
}

.line-nb {
  float: left;
  padding-right: 40px;
  margin-right: 40px;
  /*height: 100px;*/
}

.clear {
  clear: both;
  overflow: hidden;
}

.copyRight {
  margin-top: 20px;
  background-color: rgba(42, 42, 42, 1);
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
}

@media screen and (max-width: "1000px") {
  .title {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .content {
    clear: both;
  }
  .addrDetail {
    overflow: hidden;
    position: relative;
  }
  .line {
    border-right: none;
    float: none;
    padding-right: 40px;
    margin-right: 40px;
    // height: 80px;
  }
  .line1 {
    float: none;
    padding-right: 40px;
    margin-right: 40px;
    height: 100px;
    display: block;
  }
  .footerSpan {
    text-align: center;
    display: block;
  }
  .contentMobile {
    display: block;
    .footerSpan {
      text-align: left;
      display: inline-block;
    }
  }
  .copyRight {
    font-size: 12px;
  }
}
</style>
